import React, {useContext, useState} from 'react'
import {FormWrapper} from '@ilc-technology/form-renderer/react';
import StyledForm from '~components/custom/formsx/formsx.styles';
import {loader} from '~components/web-ui/form/utils/form-styles';
import {QuizContext} from '~components/custom/quiz/quiz';
import {actionTypes} from '~components/custom/quiz/quiz-state';
import {useLocalStorage} from '~helpers/useLocalStorage';
import {IStoryblokStory} from '~interfaces/storyblock';
import {filterPath} from '~components/web-ui-react/breadcrumbs/breadcrumbs-helper';

interface QuizFormProps {
  market: string;
  eventId?: string;
  onSubmissionCompleted?: () => void;
  story?: IStoryblokStory;
  form_type?: string;
  onValidationFailed?: any;
  campaignName: string;
  parsedCampaignName: string;
  questionUids: any;
}

let FORM_FIELDS = [
  'firstName',
  'lastName',
  'mobilePhone',
  'email',
  'birthDate',
  'checkboxCombined',
  'wantsBrochure'
]

/**
 * Adds an event listener to the rendered form that sends a tracking event when the user first interacts with the form
 */
const addFormStartEventListeners = (form: HTMLFormElement) => {
  const addEvtLst = () => {
    dataLayer.push({ event: 'formx.started' });
    form.removeEventListener('change', addEvtLst);
  }

  form.addEventListener('change', addEvtLst)
}

const QuizForm = (props: QuizFormProps) => {
  const {
    market,
    onSubmissionCompleted,
    campaignName = '',
    parsedCampaignName = '',
    questionUids
  } = props;

  const { quizState, quizDispatch } = useContext(QuizContext);

  const [storedState, setStoredState] = useLocalStorage({}, `ef-quiz-data-${parsedCampaignName}`)

  const filterFields = (fieldsArr: Array<string>, filterArr: Array<string>, include = false) => fieldsArr.filter((e: any) => include ?
    filterArr.includes(e.name) : !filterArr.includes(e.name));

  const [loading, setLoading] = useState(true);

  // Assign the formsX german language code for the Swiss market
  const convertedMarket = market?.toLowerCase() === 'chd' ? 'cs' : market?.substr(0, 2);

  const getPlugins = (story: IStoryblokStory) => {
    const slug = filterPath(story).filter(e => e !== 'highschool')

    return {
      tracking: {
        firstLevel: 'highschool',
        secondLevel: `${slug.join('/')}/campaign`,
        thankYouPageName: 'thankyou'
      },
      legacySettings: {
        productCode: 'HSY',
        programCode: 'HSY',
        campaignAllocationPrograms: 'HSY'
      }
    }
  }

  return (
    <StyledForm>
      {loading && <span style={{width: '150px', height: '150px'}} css={loader} />}
      <FormWrapper
        id='campaign-v2'
        formWrapperId='campaign'
        marketCode={convertedMarket}
        formWrapperCSSClass={`ef-rhps-form`}
        plugins={props.story ? getPlugins(props.story) : {}}
        onConfigurationDownloaded={(form: any) => {
          // Korean market needs to have the area code with the mobile
          if (market === 'krs') {
            FORM_FIELDS = [ 'firstName', 'lastName', 'email', 'areaCodeMobilePhone', 'mobilePhone', 'birthDate', 'checkboxCombined', 'wantsBrochure'];
          }
          // Remove unnecessary fields, ideally the form would not provide these for HSY
          form.formConfiguration.fields = [...filterFields(form.formConfiguration.fields, FORM_FIELDS, true)]

          if (market === 'noo') {
            form.formConfiguration.fields = form.formConfiguration.fields.map((field: any) => {
              if (field.name === 'birthDate') {
                const {businessRules, ...withoutBusinessRules} = field
                return withoutBusinessRules
                // field.filter((fieldOption: any) => fieldOption === 'businessRules')
              }
              return field
            })
          }

          // Remove unwanted extensions
          form.formConfiguration.scriptFiles = form.formConfiguration.scriptFiles
            .filter((e: any) => !e.pluginName.includes('google'))
        }}
        onFormRendered={(form) => {
          addFormStartEventListeners(form.htmlElement as HTMLFormElement);
          setLoading(false);

          const wantsBrochureWrapper: HTMLElement = document.querySelector('.ef-form-wantsBrochure-wrapper') as HTMLElement;
          const wantsBrochureInput: HTMLElement = document.querySelector('.ef-form-wantsBrochure-wrapper input') as HTMLElement;
          if (wantsBrochureWrapper && wantsBrochureInput) {
            wantsBrochureInput.click();
            wantsBrochureWrapper.style.display = 'none';
          }
        }}
        onPostSubmissionObjectReady={(form: any) => {
            form.data.CampaignData.CampaignAllocationPrograms = 'HSY'
            form.data.CampaignData.CampaignQuestionAnswer = [{
              Question: 'Result: ',
              Answer: ''
            }]
            form.data.CampaignData.CampaignName = campaignName
        }}
        onSubmissionCompleted={(form) => {
          dataLayer.push({ event: 'formx.submitted' });
          if (onSubmissionCompleted) {
            onSubmissionCompleted();
          } else {
            setStoredState({ ...storedState, step: Number(quizState.step) + 1, formData: form.data, formUrl: form?.formConfiguration?.submissionEndpoint, questionUids })
            quizDispatch({ type: actionTypes.incrementStep, formData: form.data, formUrl: form?.formConfiguration?.submissionEndpoint, questionUids })
          }
        }}
      />
    </StyledForm>
  )
}

export { QuizForm }
